{
  "nameInput": {
    "placeholder": "Как вас зовут?"
  },
  "signIn": {
    "tagline": "Начните с намерения.",
    "signingIn": "Вход…",
    "continueApple": "Продолжить с Apple",
    "continueApple_aria": "Продолжить с Apple",
    "continueGoogle": "Продолжить с Google",
    "continueGoogle_aria": "Продолжить с Google",
    "logo_alt": "Rhemn",
    "footer": "Выполняя вход, вы соглашаетесь с нашими условиями использования и <privacyLink>Политикой конфиденциальности</privacyLink>.",
    "divider": "или"
  },
  "email": {
    "identity": {
      "label": "Адрес электронной почты",
      "placeholder": "you@example.com",
      "change": "Изменить",
      "change_aria": "Изменить адрес электронной почты"
    },
    "password": {
      "label": "Пароль",
      "labelNew": "Придумайте пароль",
      "placeholder": "Пароль",
      "placeholderNew": "Создайте пароль",
      "show": "Показать пароль",
      "hide": "Скрыть пароль"
    },
    "actions": {
      "continue": "Продолжить",
      "signIn": "Войти",
      "createAccount": "Создать аккаунт",
      "forgot": "Забыли пароль?",
      "backToSignIn": "Вернуться ко входу",
      "iVerified": "Я подтвердил почту",
      "resend": "Отправить ссылку ещё раз",
      "resendIn": "Повторно через {{time}}",
      "signInInstead": "Войти"
    },
    "busy": {
      "checking": "Проверяем…",
      "signingIn": "Выполняется вход…",
      "creating": "Создаём ваш аккаунт…",
      "sending": "Отправляем…"
    },
    "switch": {
      "toCreate": "Впервые в Rhemn? <switchBtn>Создайте аккаунт</switchBtn>",
      "toSignIn": "Уже есть аккаунт? <switchBtn>Войдите</switchBtn>"
    },
    "strength": {
      "tooShort": "Не менее 12 символов.",
      "level1": "Хорошо. Чем длиннее, тем надёжнее.",
      "level2": "Надёжный пароль.",
      "level3": "Очень надёжный пароль."
    },
    "sent": {
      "title": "Проверьте почту",
      "body": "Мы отправили ссылку для сброса на {{email}}. Она действует один час.",
      "resent": "Отправлено повторно. Проверьте почту."
    },
    "verify": {
      "title": "Подтвердите почту",
      "body": "Мы отправили ссылку на {{email}}. Откройте её, чтобы завершить настройку аккаунта — дальше мы продолжим автоматически.",
      "waiting": "Ждём, когда вы откроете ссылку…",
      "resent": "Отправлено повторно. Проверьте почту."
    },
    "errors": {
      "invalidEmail": "Это не похоже на адрес электронной почты.",
      "missingPassword": "Введите пароль.",
      "invalidCredential": "Неверная почта или пароль.",
      "emailInUse": "У этой почты уже есть аккаунт. <signInBtn>Войдите.</signInBtn>",
      "weakPassword": "Используйте не менее 12 символов.",
      "passwordTooShort": "Используйте не менее 12 символов.",
      "passwordCommon": "Такой пароль слишком легко угадать. Попробуйте что-нибудь менее предсказуемое.",
      "emailNotVerified": "Подтвердите почту, прежде чем продолжить.",
      "providerGoogle": "Эта почта уже привязана к Google. Продолжите через Google ниже.",
      "providerApple": "Эта почта уже привязана к Apple. Продолжите через Apple ниже.",
      "userDisabled": "Этот аккаунт отключён.",
      "requiresRecentLogin": "Войдите снова, чтобы внести это изменение.",
      "sessionExpired": "Сеанс истёк. Войдите снова.",
      "expiredActionCode": "Срок действия ссылки истёк. Запросите новую.",
      "invalidActionCode": "Ссылка больше недействительна. Запросите новую.",
      "tooManyRequests": "Слишком много попыток. Подождите несколько минут или сбросьте пароль.",
      "network": "Нет соединения. Проверьте сеть и попробуйте снова.",
      "operationNotAllowed": "Вход по почте сейчас недоступен.",
      "generic": "Что-то пошло не так. Попробуйте ещё раз."
    },
    "a11y": {
      "stepEmail": "Шаг 1 из 2. Введите адрес электронной почты.",
      "stepPasswordSignIn": "Шаг 2 из 2. Введите пароль, чтобы войти.",
      "stepPasswordCreate": "Шаг 2 из 2. Придумайте пароль для нового аккаунта.",
      "stepSent": "Ссылка для сброса отправлена. Проверьте почту.",
      "stepVerify": "Аккаунт создан. Ссылка для подтверждения отправлена.",
      "resendReady": "Теперь можно отправить ссылку повторно."
    }
  }
}
